<!--模板界面-->
<template>
	<div class="bg" style="position: relative;">
		<p class="titleText">运维管理</p>
		<img src="../../../../public/static/杭州东杰定制/看板/站点概况/titleBottom.png" style="margin: 10px 0;width: 100%;">
		<vchart style="height: calc(100% - 48px);margin-top: 19px;" themes="dongjieEchart" ref='vchart'></vchart>
		<p class="orderCount flexCenter">总单数 : <span>{{qx+xj+xs}}</span> </p>
		<div class="orderBox flexCenterColumn" style="top: 100px;left: 20px;">
			<div class="flexStart">
				<div class="pointBox" style="background: #5195f2;"></div>
				<p>巡视工单</p>
			</div>
			<p>{{xs}}</p>
		</div>
		<div class="orderBox flexCenterColumn" style="top: 100px;right: 20px;">
			<div class="flexStart">
				<div class="pointBox" style="background: #14f1f4;"></div>
				<p>巡检工单</p>
			</div>
			<p>{{xj}}</p>
		</div>
		<div class="orderBox flexCenterColumn" style="bottom: 10px;left: 20px;">
			<div class="flexStart">
				<div class="pointBox" style="background: #f4a214;"></div>
				<p>抢修工单</p>
			</div>
			<p>{{qx}}</p>
		</div>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart
		},
		props: {},
		data() {
			return {
				options: {
					tooltip: {
						trigger: 'item',
						formatter: "{a}</br>{b} : {c} ({d}%)"
					},
					legend: {
						show: false,
					},
					series: [{
						name: '占比',
						type: 'pie',
						radius: ['25%', '45%'],
						data: [],
						label: {
							show: false
						},
					}],
				},
				xj: 0,
				xs: 0,
				qx: 0
			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.options.series[0].itemStyle = {
				normal: {
					opacity: 0.7,
				}
			}
			this.$refs.vchart.setData(this.options)
			this.initData()
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
		},
		watch: {
			nowUnit(nv, ov) {
				this.initData()
			}
		},
		methods: {
			initData() {
				if (isempty(this.nowUnit)) {
					var list = []
					list.push({
						name: "抢修工单",
						value: 0
					})
					list.push({
						name: "巡检工单",
						value: 0
					})
					list.push({
						name: "巡视工单",
						value: 0
					})
					this.options.series[0].data = list
					this.$refs.vchart.setData(this.options, true)
				} else {
					//从投运开始,如果没写时间就这个月
					this.$api.orderApi.countOrderListByUnit(this.nowUnit.id, getValueIfNoNull(this.nowUnit.joinTime, new Date(new Date()
						.formatByMonth()).getTime()), Date.now(), respon => {
						var list = []
						for (var i = 0, len = respon.length; i < len; i++) {
							var item = respon[i]
							list.push({
								name: item.groupName,
								value: getValueIfNoNull(item.count, 0)
							})
							switch (item.groupName) {
								case '巡检工单':
									this.xj = getValueIfNoNull(item.count, 0)
									break
								case '巡视工单':
									this.xs = getValueIfNoNull(item.count, 0)
									break
								case '抢修工单':
									this.qx = getValueIfNoNull(item.count, 0)
									break
							}
						}
						this.options.series[0].data = list
						this.$refs.vchart.setData(this.options, true)
					})
				}
			}
		}
	}
</script>

<style scoped>
	.bottomImg {
		width: 80%;
		margin: 5% 10% 0 10%;
	}

	.orderCount {
		top: 49px;
		width: 200px;
		padding: 10px;
		left: calc(50% - 105px);
		text-align: center;
		position: absolute;
		background-image: url(/static/杭州东杰定制/看板/运维分析/cycleBg.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.orderCount>span {
		color: #ed7310;
		font-size: 16px;
		font-weight: bold;
		padding: 0 10px;
	}

	.orderBox {
		position: absolute;
		width: 90px;
		height: 40px;
		background-image: url(/static/杭州东杰定制/看板/运维分析/boxBg.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.pointBox {
		height: 10px;
		width: 10px;
		border-radius: 50%;
		margin-right: 10px;
	}
</style>
